(() => {
  const root = document;
  const closeMenus = () => {
    root.querySelectorAll('[data-vjb-menu], [data-vjb-search-toggle]').forEach(button => {
      button.setAttribute('aria-expanded', 'false');
      const panel = root.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  };
  const setProject = (project, shape) => {
    const form = root.querySelector('.vjb-quote-form');
    if (!form) return false;
    const select = form.querySelector('[data-vjb-project-field]');
    const brief = form.querySelector('[data-vjb-brief]');
    if (select && project && [...select.options].some(option => option.value === project)) select.value = project;
    if (brief && shape && !brief.value.includes(shape)) brief.value = 'I am interested in ' + shape + '. ' + brief.value;
    return true;
  };
  root.addEventListener('click', event => {
    const toggle = event.target.closest('[data-vjb-menu], [data-vjb-search-toggle]');
    if (toggle) {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      closeMenus();
      const panel = root.getElementById(toggle.getAttribute('aria-controls'));
      toggle.setAttribute('aria-expanded', String(open));
      if (panel) { panel.hidden = !open; if (open && toggle.matches('[data-vjb-search-toggle]')) panel.querySelector('input')?.focus(); }
    }
    const link = event.target.closest('[data-vjb-project], [data-vjb-shape]');
    if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && setProject(link.dataset.vjbProject || 'Logo on an existing shape', link.dataset.vjbShape)) {
      event.preventDefault();
      const quote = root.getElementById('quote');
      quote?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', '#quote');
    }
    if (event.target.closest('.vjb-mobile-nav a')) closeMenus();
    if (event.target.closest('[data-vjb-reset]')) {
      root.querySelectorAll('[data-vjb-keywords]').forEach(card => { card.hidden = false; });
      root.querySelectorAll('[data-vjb-search] input').forEach(input => { input.value = ''; });
      root.querySelectorAll('[data-vjb-empty]').forEach(el => { el.hidden = true; });
      root.querySelectorAll('[data-vjb-search-status]').forEach(el => { el.textContent = ''; });
    }
  });
  root.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(); });
  root.addEventListener('submit', event => {
    if (!event.target.matches('[data-vjb-search]')) return;
    const cards = [...root.querySelectorAll('[data-vjb-keywords]')];
    if (!cards.length) return;
    event.preventDefault();
    const query = event.target.querySelector('input').value.trim().toLowerCase();
    let count = 0;
    cards.forEach(card => { card.hidden = Boolean(query) && !query.split(/\s+/).every(word => card.dataset.vjbKeywords.includes(word)); if (!card.hidden) count++; });
    root.querySelectorAll('[data-vjb-empty]').forEach(el => { el.hidden = count > 0; });
    root.querySelectorAll('[data-vjb-search-status]').forEach(el => { el.textContent = query ? `${count} shape categories match “${query}”.` : ''; });
    root.getElementById('shapes')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  root.addEventListener('shopify:section:load', closeMenus);
  const params = new URLSearchParams(location.search);
  if (params.has('shape') || params.has('project')) setProject(params.get('project') || 'Logo on an existing shape', params.get('shape'));
})();
